<template>
  <div class="singIn forgetPsw">
    <div class="logo">
      <div class="backIcon">
        <i
          class="el-icon-back cursor"
          @click="goBack"></i>
      </div>
      <div class="tvuLogo">
        <!-- <img src="./../assets/img/TVU networks Copy.png" alt=""> -->
      </div>
    </div>
    <div class="formBody">
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.forget')}}</p>
        <p class="tvuDescribe">{{$t('lang.forgetTip')}}</p>
      </div>
      <div class="singInForm">
        <div class="exchange emailArea ">
          <div class="tip">{{$t('lang.email')}}</div>
          <el-input
            class="input focusFade"
            tabindex='1'
            v-model="email"
            maxlength="50"
            :placeholder="$t('lang.email')"
            @keyup.enter.native="nextOpaertaion"
            @focus="focusInput"
            @blur="blurInput(1)"></el-input>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{emailErrorTip}}</span>
          </div>
        </div>
        <div class="exchange vertical">
          <el-input
            v-model="vcode"
            class="vcodeInput"
            tabindex='2'
            :placeholder="$t('lang.vcodePlaceholder')"
            @keyup.enter.native="nextOpaertaion"></el-input>
          <div class="vcode">
            <img
              :src="'data:image/jpeg;base64,'+imgUrl"
              alt=""
              @click='getVcode'>
          </div>
          <div class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.vcodeEror')}}</span>
          </div>
        </div>
        <div class="confirmArea">
          <span
            class="cursor createAccount"
            @click='goToCreate'>{{$t('lang.createAccount')}}</span>
          <el-button
            class="confirmBtn cursor"
            v-repeat-click="{event:nextOpaertaion}"
            :disabled='isDisabeBtn'>{{$t('lang.next')}}</el-button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'CreateAccount',
  data () {
    return {
      email: '',
      vcode: '',
      isDisabeBtn: true,
      emailErrorTip: '',
      verifyCode: {},
      imgUrl: ''
    }
  },
  mounted () {
    // 初始化验证码
    // this.verifyCode = new GVerify({
    // 	id : "vcode",
    // 	type : "blend"
    // });
    this.getVcode()
  },
  watch: {
    email: function (newVal) {
      if ($('.emailArea').hasClass('errorInput')) {
        $('.emailArea').removeClass('errorInput')
      }
      if (!newVal || !this.vcode) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    },
    vcode: function (newVal) {
      if ($('.vertical').hasClass('errorInput')) {
        $('.vertical').removeClass('errorInput')
      }
      if (!newVal || !this.email) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    key () {
      return this.$store.state.key
    },
    location () {
      return this.$store.state.location
    }
  },
  methods: {
    goBack () {
      ga('send', 'event', 'newUserService-forgetPsw-goBack', 'click')
      this.$router.go(-1)
    },
    goToCreate () {
      ga('send', 'event', 'newUserService-forgetPsw-leave', 'click')
      this.$router.push('/create')
    },
    getVcode () {
      this.axios.get(
        '/userGroup/user-group/login/getVCode',
        {
          width: 80,
          height: 40
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        if (res.data.errorCode == '0x0') {
          this.imgUrl = res.data.result.vCode
          this.$store.state.key = res.data.result.key
        } else {
          this.$message({
            message: this.$t('lang.error80943601'),
            type: 'error',
            duration: 3000
          })
        }
      }).catch()
    },
    nextOpaertaion () {
      ga('send', 'event', 'newUserService-forgetPsw-changePsw', 'click')
      if (!this.email || !this.vcode) {
        this.isDisabeBtn = true
        return
      }
      this.isDisabeBtn = false

      // let reg = /^([\w+.-]*[+-]*\.*)+@(\w-?)+(\.\w{2,})+$/
      // if(!reg.test(this.email)){
      // 	$('.emailArea').addClass('errorInput');
      // 	this.emailErrorTip = 'Email format incorret';
      //     return;
      // }
      this.axios.post(
        '/userGroup/user-group/login/forgotPassword',
        this.qs.stringify({
          email: this.email,
          imgCode: this.vcode,
          key: this.key,
          url: this.location
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      ).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 注册成功
        if (res.data.errorCode == '0x0') {
          this.$message({
            message: this.$t('lang.errorAccount'),
            type: 'success',
            duration: 3000
          })
          if (this.$store.state.userInfo) {
            this.$store.state.userInfo.email = this.email
          }
          // this.$store.state.userInfo.email = this.email
          localStorage.setItem('userInfo', JSON.stringify({ email: this.email }))
          // localStorage.setItem('userInfo',JSON.stringify(this.$store.state.userInfo))
          this.$router.push({ path: '/verify', query: { verifyFlag: 0 } })
        } else if (res.data.errorCode == '80943701') {
          this.$message({
            message: this.$t('lang.error80943701'),
            type: 'error',
            duration: 3000
          })
          this.getVcode()
        } else if (res.data.errorCode == '80943702') {
          this.$message({
            message: this.$t('lang.error80943702'),
            type: 'error',
            duration: 3000
          })
        } else if (res.data.errorCode == '80943301') {
          this.$message({
            message: this.$t('lang.errorAccount'),
            type: 'error',
            duration: 3000
          })
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch()
    },
    focusInput (event) {
      $(event.target).parent().prev('.tip').css({
        display: 'inline-block',
        color: 'rgba(51,171,79,1)'
      })
    },
    blurInput (num) {
      // num ,1代表email失去焦点，2代表companyName失去焦点
      $(event.target).parent().prev('.tip').css('color', 'rgba(153,153,153,1)')
      if (num == 1) {
        this.email ? '' : $(event.target).parent().prev('.tip').css('display', 'none')
      }
    }
  },
  filters: {
    getStrength (val) {
      switch (val) {
        case 2:
          return this.$t('lang.low')
        case 4:
          return this.$t('lang.middle')
        case 6:
          return this.$t('lang.high')
        default:
          break
      }
    }
  }
}
</script>
